<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb class="hamburger-inner"></breadcrumb>
    <el-link v-show="showBack" class="hamburger-back" type="primary" @click="goBack">
      <i class="el-icon-back"></i>返回
    </el-link>

    <div class="rightOperation">
      <el-dropdown trigger="hover" split-button @command="messageClick" @click="messgaeBtn">
        <el-badge
          :value="noticeList.length>99?'99+':noticeList.length"
          class="noticeBox el-dropdown-link"
        >
          <i class="el-icon-message-solid"></i>
        </el-badge>
        <el-dropdown-menu class="message-container" slot="dropdown">
          <el-dropdown-item
            v-for="(item,index) in noticeList"
            :command="item.id"
            :key="index"
          >{{item.title}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img class="user-avatar" :src="avatar" /> -->
          <img class="user-avatar" src="../../../assets/images/user.png" />
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>
</template>

<script>
import { setMessageStatus } from "@/api/message.js";
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";

export default {
  data() {
    return {
      showBack: false,
    };
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "noticeList", "userId"])
  },
  created() {
    this.getMessageList();
  },
  methods: {
    getMessageList() {
      this.$store.dispatch("getNoticeList", {
        toId: this.userId,
        readFlag: 0,
        pageSize: 100,
        pageNum: 1
      });
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        // 退出登录清除ws监听
        if (window.noticeWs) {
          window.noticeWs.close();
          window.noticeWs = null;
        }
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    // 返回
    goBack() {
      this.$router.back(-1);
    },
    // 点击跳转收件箱
    messgaeBtn() {
      this.$router.push("/inbox");
    },
    // 悬浮消息通知列表
    messageClick(id) {
      let data = this.noticeList.filter(m => m.id == id)[0];
      let dataId = JSON.parse(data.content).id;
      if (dataId) {
        setMessageStatus({
          id
        }).then(res => {
          this.getMessageList();
          if (data.type == "10003") {
            // 预警添加
            this.$router.push({
              path: "/patrol/warning/details",
              query: {
                id: dataId
              }
            });
          } else if (data.type == "1004") {
            // 巡检任务添加
            this.$router.push({
              path: "/patrol/scheme/details",
              query: {
                id: dataId
              }
            });
          } else if (data.type == "10010" || data.type == "10009") {
            // 预警方案关闭
            this.$router.push({
              path: "/flood/scheme/details",
              query: {
                id: dataId
              }
            });
          } else {
            // 工单添加
            this.$router.push({
              path: "/patrol/workorder/approvalDetails",
              query: {
                id: dataId
              }
            });
          }
        });
      }
    }
  },
  mounted() {
    // let path = this.$route.path
    // console.log('----')
    // console.log(path.indexOf('list'))
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        let path = this.$route.path;
        if (path.indexOf("list") > -1 || path.indexOf("home") > -1) {
          this.showBack = false;
        } else {
          this.showBack = true;
        }
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .hamburger-inner {
    float: left;
  }
  .hamburger-back {
    float: left;
    margin-left: 20px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .rightOperation {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 300px;
    line-height: normal;
    .noticeBox {
      i {
        font-size: 22px;
        color: #999999;
      }
    }
  }
}
/deep/ .el-button-group > .el-button:not(:last-child) {
  height: 40px;
  padding: 10px 23px;
  margin-right: -1px;
}
/deep/ .el-button-group > .el-button:last-child {
  height: 40px;
}
/deep/.el-dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue